import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "submit"];

  connect() {
    this.syncSubmitState();
  }

  onCheckboxChange() {
    this.syncSubmitState();
  }

  syncSubmitState() {
    if (!this.hasSubmitTarget || !this.hasCheckboxTarget) return;
    this.submitTarget.disabled = !this.checkboxTarget.checked;
  }
}
